import { QuestionCircleOutlined } from '@ant-design/icons';
import { Dropdown, Button } from 'antd';
import { setLocale, getLocale } from '@umijs/max';
import React from 'react';

export type SiderTheme = 'light' | 'dark';

const LOCALE_CODES: Record<string, string> = {
  'en-US': 'EN',
  'ru-RU': 'RU',
  'tj-TJ': 'TJ',
};

export const SelectLang = () => {
  const currentLocale = getLocale();
  const currentCode = LOCALE_CODES[currentLocale] ?? 'RU';

  const languageOptions = [
    { key: 'en-US', label: 'EN' },
    { key: 'ru-RU', label: 'RU' },
    { key: 'tj-TJ', label: 'TJ' },
  ];

  const handleLanguageChange = ({ key }: { key: string }) => {
    setLocale(key, false);
  };

  return (
    <Dropdown
      menu={{
        items: languageOptions,
        onClick: handleLanguageChange,
        selectedKeys: [currentLocale],
      }}
      trigger={['click']}
      placement="bottomRight"
    >
      <Button
        type="text"
        aria-label={currentCode}
        style={{
          padding: '4px 8px',
          height: 28,
          minWidth: 36,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: 'none',
          boxShadow: 'none',
          borderRadius: 4,
          fontWeight: 600,
          letterSpacing: 0.4,
        }}
      >
        {currentCode}
      </Button>
    </Dropdown>
  );
};

export const Question = () => {
  return (
    <div
      style={{
        display: 'flex',
        height: 26,
      }}
      onClick={() => {
        window.open('https://pro.ant.design/docs/getting-started');
      }}
    >
      <QuestionCircleOutlined />
    </div>
  );
};
